import React, { createContext, useState } from 'react';

export const PeopleContext = createContext();

export const PeopleProvider = ({ children }) => {
  const [people, setPeople] = useState([]);

  const addPerson = (name, department) => {
    if (!name || !department) return;
    setPeople([...people, { name, department }]);
  };

  const updatePerson = (index, updated) => {
    const updatedPeople = [...people];
    updatedPeople[index] = updated;
    setPeople(updatedPeople);
  };

  return (
    <PeopleContext.Provider value={{ people, addPerson, updatePerson }}>
      {children}
    </PeopleContext.Provider>
  );
};
